export default from './loader';



// WEBPACK FOOTER //
// ./app/components/loader/index.js